import React from 'react';

import Tooltip, { TooltipProps } from './Tooltip';
import Box, { BoxProps } from '../Box';

interface DisableAbleProps extends BoxProps {
  disabled?: boolean;
}

const WithTooltip =
  <P extends DisableAbleProps>(
    Component: React.ComponentType<P>,
  ): React.FC<P & Partial<Omit<TooltipProps, 'children'>>> =>
  ({ label, placement, ...rest }) => {
    if (label) {
      return (
        <Tooltip label={label} placement={placement}>
          <Box>
            <Component {...(rest as P)} disabled />
          </Box>
        </Tooltip>
      );
    }

    return <Component {...(rest as P)} />;
  };

export default WithTooltip;
